import { TeacherWorkloadsPage } from 'pages/TeacherWorkloads';
import { appRouterPaths } from 'services/navigation';
import type { AppRouteProps } from '../types';

export const teacherWorkloadsPageRoute: AppRouteProps = {
  path: appRouterPaths.teacherWorkloads,
  element: <TeacherWorkloadsPage />,
};
